export class SendContact {
  constructor(public params: {label: string; msisdn: string}) {
  }
}

export class DataFromOverlay {
  constructor(public params: any) {
  }
}

export class SetSession {
  constructor(public params: any) {
    console.log('Set Session called', params);
  }
}

export class SetMsisdn {
  constructor(public params: any) {
  }
}

export class IsShaking {
  constructor() {
  }
}

export class CloseRequest {
  constructor() {
  }
}

/**
 * method for handle setBackButton
 */
export class Load {
  constructor(public url: string) {
  }
}

/**
 * method for handle otp flow, param boolean from client, if true otp flow is skipped
 */
export class SetOtpFlowDoneStatus {
  constructor(public otpValid: string) {
  }
}

export type BridgeApiEvent = SendContact | DataFromOverlay | SetSession | SetMsisdn | IsShaking | CloseRequest;
